import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  CircularProgress,
} from '@mui/material';
import { useLanguage } from '../../i18n/LanguageContext';

interface WorkoutSet {
  series: number;
  reps: number;
  weight: number;
}

interface RecentWorkout {
  date: string;
  sets: WorkoutSet[];
}

interface RecentWorkoutsDialogProps {
  open: boolean;
  onClose: () => void;
  exerciseName: string;
  recentWorkouts: RecentWorkout[];
  loading: boolean;
}

export const RecentWorkoutsDialog: React.FC<RecentWorkoutsDialogProps> = ({
  open,
  onClose,
  exerciseName,
  recentWorkouts,
  loading,
}) => {
  const { t } = useLanguage();

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{t('recentWorkouts.title', { exerciseName })}</DialogTitle>
      <DialogContent>
        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', my: 4 }}>
            <CircularProgress />
          </Box>
        ) : recentWorkouts.length > 0 ? (
          recentWorkouts.map((workout: RecentWorkout, index) => (
            <Box key={index} sx={{ mb: 2 }}>
              <Typography variant="h6">{new Date(workout.date).toLocaleDateString()}</Typography>
              <ul>
                {workout.sets.map((set: WorkoutSet, i: number) => (
                  <li key={i}>
                    <Typography>
                      {t('recentWorkouts.set', { series: set.series, reps: set.reps, weight: set.weight })}
                    </Typography>
                  </li>
                ))}
              </ul>
            </Box>
          ))
        ) : (
          <Typography>{t('recentWorkouts.noData')}</Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          {t('common.close')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
